module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-120x120-947e9d8016ecd7e3403ed82b450c6b41.png";